"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { cn } from "@local/utils/src/cn";
import { useScrollDirection } from "../../../lib/useScrollDirection";
interface StickyHeaderProps {
  height: number;
  sticky: boolean;
  children: ReactNode;
}
export const StickyHeader = t0 => {
  const $ = _c(13);
  const {
    height,
    sticky,
    children
  } = t0;
  const dir = useScrollDirection(sticky, height);
  let t1;
  if ($[0] !== dir || $[1] !== height || $[2] !== sticky) {
    t1 = sticky && {
      top: dir === "down" ? -height : 0
    };
    $[0] = dir;
    $[1] = height;
    $[2] = sticky;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== height || $[5] !== t1) {
    t2 = {
      height,
      ...t1
    };
    $[4] = height;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = sticky ? "fixed z-100 transition-all duration-300 ease-in-out" : "";
  let t4;
  if ($[7] !== t3) {
    t4 = cn("w-full", t3);
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t2 || $[11] !== t4) {
    t5 = <header style={t2} className={t4}>{children}</header>;
    $[9] = children;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};